<div class="dd-v-spec-dealer-option">
  <dd-vehicle-detail-header
    [vehicleDetails]="vehicle"
    [sharedData]="shared"
  ></dd-vehicle-detail-header>
  <dd-app-menu></dd-app-menu>
  <!-- <div class="dd-v-spec-dealer-option-header">Available Optional Accessories</div> -->
  <div>
      <dd-page-title [title]="'Available Optional Accessories (' + dealerOptions?.length + ')'"></dd-page-title>
  </div>
  <!-- <div class="dd-v-spec-dealer-option-category">
    <ul class="dd-v-spec-dealer-option-category-items">
      <li
        class="dd-v-spec-dealer-option-category-item"
        *ngFor="let category of carousel.categories"
        (click)="onCategory($event, category)"
      >
        <span [class.active]="category?.active"
          >{{ category?.label }}&nbsp;({{ category?.count }})</span
        >
      </li>
    </ul>
  </div> -->
  <div class="dd-v-spec-dealer-option-carousel">
    <div class="dd-v-spec-dealer-option-carousel-inner">
      <rti-carousel [style]="carousel.style" [page-size]="1" [indicators]="false" [showMobileOverlay]="true">
        <rti-carousel-item
          *ngFor="let dealerOption of dealerOptions; let idx = index"
           [hidden]="dealerOption.hidden"
           [class.active]="dealerOption.active">
          <rti-card
            class="standard-card"
            [uid]="dealerOption.uid"
            [style]="dealerOption.style"
            [hidden]="dealerOption.hidden"
            [animate]="dealerOption.animate"
            [actions]="cardActions"
            [cardIndex]="(idx + 1) + '/' + dealerOptions?.length"
          >
            <div class="dd-v-spec-dealer-option-carousel-context">
              <img [attr.src]="dealerOption.image?.href" *ngIf="(dealerOption?.image?.href !== null)" ddAppImageError/>
              <img src="assets/images/dealer-option-no-image.jpg" *ngIf="(dealerOption?.image?.href === null)"/>
              <div class="dealer-option-container">
                  <label class="dealer-option">{{ dealerOption.marketingName }}</label>
              </div>
              <div>
                <label class="retailPrice"><span>$</span>{{ dealerOption.retailPrice }}</label><span>Installed Price</span>
              </div>
            </div>
          </rti-card>
        </rti-carousel-item>
      </rti-carousel>
    </div>
  </div>
  <rti-modal-dialog
    *onActionClick="[handleAccessoryEvent]"
    [actions]="dialogActions">
    <div class="rti-dealer-option-detail-header" header-text>{{dealerOption.marketingName}}</div>
    <rti-dealer-option-detail [model]="dealerOption"></rti-dealer-option-detail>
  </rti-modal-dialog>
</div>
